import React from 'react'
import { useParams } from 'react-router';
import { useState, useEffect } from 'react';
import ProductGrid4 from '../../components/public/pages/home/productGrid4';
import ApiUrl from '../../configTools/apiUrl';

const StateList = () => {
    const {id} = useParams();
    const [products,setProducts] = useState([]);
    const [collection,setCollection] = useState({
        id :id,
        title:"",
        discription:""
    });
    useEffect(() => {
      fetch(ApiUrl.API_URL_ListingState+"/1")
      .then(res=>res.json())
      .then(data =>{
          if(data.success){
            console.log(id);
            if(id === '1'){
              setProducts(data.responce.data1);
            }
            if(id === '2'){
              setProducts(data.responce.data2);
            }
            if(id === '3'){
              setProducts(data.responce.data3);
            }
          }
      });
      if(id === '1'){
        setCollection({
            id : id,
            title:"Kaay Closet",
            discription:""
        })
      }
      else if(id === '2'){
        setCollection({
            id : id,
            title:"New on Kaay",
            discription:""
        })
      }
      else if(id==='3'){
        setCollection({
            id : id,
            title:"Art & Craft",
            discription:""
        })
      }
    },[id])
  return (
    <div>
        <div style={{ margin:"0px 40px"}}>
            <div className='collection_heading'>
                <h3>{collection.title}</h3>
                <p>{collection.discription}</p>
            </div>
            <ProductGrid4 Products={products} Columns={5}/>
        </div>
    </div>
  )
}

export default StateList
